import compact from 'lodash/compact';
import sumBy from 'lodash/sumBy';
import routineLogo from 'assets/images/short-lighto-logo.png';
import { formatMoney, getTotalQuantiy } from 'utils/formattedString';
import { DynamicObjectType } from 'types/commons';
import { formatDateStr } from 'core/helper/formatString';

export const genSmallLabelPackage = (order) =>
  new Promise((resolve) => {
    resolve(`<section style="display:flex; align-items:center;">
  <div style="position:relative; width: 9.7cm; min-height: 9.7cm; max-height: 9.7cm; height: 9.7cm; overflow: hidden; text-overflow: ellipsis; font-size: 12px; border:2px solid #000; border-radius: 20px; display: flex;
   flex-direction: column; margin:5px;">
     <div style="display:flex;padding: 5px 10px;  justify-content: space-between; gap: 10px">
     <div style="width: 60px; min-width: 60px; display: flex; align-items: center">
     <img src="${
       order?.chainStore?.logo || routineLogo
     }" style="width: 100%; object-fit: contain; filter: brightness(0);" /></div>
        <div style="text-align: left;font-size: 9px; flex-grow: 2;display:flex; align-items:flex-start; flex-direction:column; justify-content:center;">
           <div style="line-height: 11px;">
           <div><strong>${order?.chainStore?.name || 'routine'} Vietnam (${
             order?.chainStore?.siteUrl || 'routine.com.vn'
           })</strong>
            </div>
            <div style="font-size: 9px;">${
              order?.chainStore?.data?.companyName ||
              'CÔNG TY TM DV TỔNG HỢP HOÀN VŨ'
            }
            </div>
            <div style="font-size: 9px;">${
              order?.chainStore?.data?.address ||
              '294 Hai Bà Trưng, P. Tân Định Q1, TP.HCM'
            }
            </div>
            ${
              order?.chainStore?.data?.hotline
                ? `
              <div style="font-size: 9px;">Hotline: ${order?.chainStore?.data?.hotline}</div>
            `
                : ''
            }
            </div>
           
           
        </div>
        <img width="40px" src="${
          order?.partner?.data?.thumbnail
        }" style="object-fit: contain; filter: brightness(0);" />
     </div>
     <div style="display:flex; flex:1; flex-direction:column; padding-top: 2px; width: 100%; border-top: 1px solid #000;">
     <div style="display:flex;">
        <div style="flex:2; text-align:left; padding: 0px; justify-content: space-between; font-size: 9px;">
           <div style="padding: 0 3px 2px; display:flex;">
              <canvas style="height: 55px;" id="sale-order-id-${
                order?.id
              }"></canvas>
              <div style="width: 25%;display:flex; flex-direction: column; justify-content:center;  align-items:center;flex:1;font-size: 8px; text-align:left;">
              <canvas class="order-qrcode-img" id="qr-ordernumber-${order?.id}"></canvas>
           </div>
           </div>

          <div style="text-align:left; display:flex; padding: 0px; justify-content: space-between; font-size: 9px;">
          <div style="flex:1; padding: 0 3px 2px;">
            <div style="font-size:13px; padding-left: 5px; font-weight:800;width: 100%; display: flex; justify-content: space-between; padding-right:10px;">${
              order?.id
            }  <b>${order?.orderNumber}</b></div>
          </div>
          
      </div>
        </div>
        <ul style="width: 130px; list-style: none; padding-left: 0px; border-left: 1px solid #000; text-align:left; font-size: 8px; line-height: 11px;">
            <li style='padding-left: 5px;'>• Không đồng kiểm</li>
            <li style='padding-left: 5px;'>• <span style="font-weight: 600;text-transform: uppercase;">Vui lòng quay phim khi mở hàng</span></li>
            <li style='padding-left: 5px;'>• Một số sản phẩm có thể không thể hiện rõ do danh sách quá dài</li>
            <li><div style="font-size:10px;"><i>Thu COD: </i><b>${
              order?.payments?.find((e) => e.type === 'cod') ||
              order?.paymentType === 'cod'
                ? formatMoney(
                    order?.payments?.length > 0
                      ? sumBy(
                          order?.payments?.filter((e) => e.type === 'cod'),
                          (e: DynamicObjectType) => +e.amount,
                        )
                      : order?.total,
                    undefined,
                    undefined,
                    ' ',
                  )
                : 0
            } VND</b></div></li>
        </ul>
     </div>
     <div style="display:flex; border-top: 1px solid #000; height: 55px">
     <div  style="padding: 2px 5px;font-size: 8px; text-align:left; flex:2;">
       <div style="font-size: 9px; line-height: 11px;">
       Người nhận: <b>${[
         `${order?.address?.firstName || ''} ${order?.address?.lastName || ''}`,
         compact([
           order?.address?.addressLine1,
           order?.address?.addressLine2,
           order?.address?.ward,
           order?.address?.district,
           order?.address?.province,
         ]).join(', '),
         order.address?.telephone,
       ].join(' | ')}</b>
       <br/>
       ${
         order?.address?.what3words
           ? `<div style="display:flex; align-items:center;">
           <img height="15px" style="margin-right: 10px; margin-top: 2px;" src="https://res.cloudinary.com/hsv-search-image/image/upload/v1666241387/w3wlogo2_lkhs2l.png" />
       /// ${order?.address?.what3words}
       </div>`
           : ''
       }
       </div>
    </div>
     </div>
    <div style="display: flex; border-top: 1px solid #000;">

    <div style="display:flex; padding: 0 3px 2px; flex: 2;">
    <div style="margin-right: 10px; margin-left: 5px;">
     <canvas style="height: 55px;"  id="customer-order-id-${
       order?.id
     }"></canvas>
     <div><b style="font-size:13px; margin-right: 10px;">${
       order?.deliveryCode
     }</b></div>
       </div>
             ${
               order?.sortCode
                 ? `<div style="width: 25%;display:flex; flex-direction: column; justify-content:center;  align-items:center;flex:1;font-size: 8px; text-align:left;">
            <canvas class="order-qrcode-img" id="qr-sortcode-${order?.id}"></canvas>
            <div style="font-size:9px;font-weight: 600;">
               ${order?.sortCode}
            </div>
         </div>`
                 : ''
             }
    </div>

    <div style="border-left: 1px solid #000; width: 130px; padding: 2px 0px; padding-left: 3px;text-align:left;">
    <b style="font-size: 9px;">Chữ ký khách hàng</b>
 </div>
    </div>
        <div style="flex:1; font-size: 8px; align-items:center;   padding: 5px 10px; flex:1; border-top: 2px solid #000;">
        <div style="display:flex; justify-content: space-between;">
        <div>
        <span>Tổng số lượng sản phẩm:</span> <b>${getTotalQuantiy(
          order?.items,
        )}</b></div>
        <div><span>Ngày xử lý đơn:</span> <span style="font-size: 9px;font-weight: 600;">${formatDateStr(
          order?.updatedAt,
        )}</span></div>
        
        
        </div>
        
        
           <div  style="text-align:left;">
              <div style='
              overflow: hidden;
              text-overflow: ellipsis;
              height: 61px;
              line-height: 12px;
          '>
              ${order?.items
                ?.map(
                  (e, index) =>
                    `<div>${index + 1}. ${compact([
                      e?.product?.productType?.detail?.find(
                        (e) => e?.langCode === 'vi',
                      )?.name ||
                        e?.product?.productType?.detail?.find(
                          (e) => e?.langCode === 'en',
                        )?.name ||
                        e?.product?.productType?.slug ||
                        '',
                      e?.ItemDescription,
                      e?.VariantId,
                      e?.variantSku,
                    ]).join(', ')} x ${e.quantity}</div>`,
                )
                ?.join('')}
              </div>
           </div>
        </div>
        
     </div>
     
     
  </div>
  </section>`);
  });
